import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/getHours/index.js';

var require$$20 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$20 as default };
